import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function updateArtworksOrder(data, id) {
  return fetchWrapper.put(`${config.apis.api.url}/internalcollection/updateartworksorder/${id}`, {
    injectToken: true,
    body: data
  });
}
function updateCollectionsOrder(data, is_mobile) {
  return fetchWrapper.put(`${config.apis.api.url}/internalcollection/updateorder/${is_mobile}`, {
    injectToken: true,
    body: data
  });
}

function updateCollectionVisibility(data, is_mobile) {
  const body = { value: data.value,is_mobile };
  return fetchWrapper.put(`${config.apis.api.url}/internalcollection/updatevisibility/${data.collectionId}`, {
    injectToken: true,
    body
  });
}

function updateContentMode(collectionId, content_mode) {
  return fetchWrapper.put(`${config.apis.api.url}/internalcollection/content-mode/${collectionId}/`, {
    injectToken: true,
    body: { content_mode }
  });
}

const InternalCollectionService = {
  updateArtworksOrder,
  updateCollectionsOrder,
  updateCollectionVisibility,
  updateContentMode
};

export default InternalCollectionService;
